import { DataTable } from "simple-datatables";

const myTable = document.querySelector("#industry-ranking");
if (myTable) {
  const dataTable = new DataTable(myTable, {
    searchable: false,
    nextPrev: false,
    layout: {
      top: "",
      bottom: "",
    },
    perPage: 9999,
  });
}
